module.exports = __webpack_public_path__ + "img/A61-20190408_03.668e30cd.jpg";